import { HttpContextToken } from '@angular/common/http';

/** Client-side only: suppresses the global loader without adding a header (which would trigger a CORS preflight). */
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);
